import React from "react";
import  styles from'./About.module.scss';
import logo from 'assets/img/GoodCard-logo.png';
const About = props => {

    return (
        <div className={styles.box}>
            <img src={logo} alt="FAQ" className={styles.logo} />
            <div className={styles.title}>
                Sobre o Aplicativo Good Card
            </div>
            <div className={styles.description}>
            O aplicativo Good Card foi criado para disponibilizar aos nossos clientes um acesso fácil à rede de estabelecimentos credenciados, para que você possa usufruir de todos os benefícios que nosso cartão oferece, a qualquer momento e próximo a você.
            </div>
            <div className={styles.boxLink}>
                <a href="http://www2.goodcard.com.br/pdf/Politica_de_Privacidade_Good_Card.pdf" target="blank" className={styles.link}>Termos de uso do aplicativo</a>
            </div>
        </div>

    );
};

export default About;